import React, { useEffect, useState } from"react";
import axios from"axios";

const badgeIcons = {
"Bug Hunter":"🐛",
"Optimizer":"⚡",
"Clean Coder":"🧼"
};

const UserBadges = ({ userId, token }) => {
 const [badges, setBadges] = useState([]);

 useEffect(() => {
 axios.get(`http://localhost:5000/api/secure/badges/${userId}`, {
 headers: { Authorization: `Bearer ${token}` }
 })
 .then(res => setBadges(res.data))
 .catch(err => console.error("Badge fetch error", err));
 }, [userId, token]);

 return (
 <div style={{ padding:"1rem" }}>
 <h4>🎖 Your Badges</h4>
 {badges.length === 0 ? (
 <p>No badges yet</p>
 ) : (
 <ul>
 {badges.map((b, i) => (
 <li key={i}>{badgeIcons[b.badge] ||"🏅"} {b.badge}</li>
 ))}
 </ul>
 )}
 </div>
 );
};

export default UserBadges;



